import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import CreateInvoice from './CreateInvoice';
import { BaseInvoiceDTO, CreateInvoiceDTO, ProjectData } from './invoice.type';

interface CreatePastInvoiceDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (invoice: CreateInvoiceDTO) => void;
  projectData?: ProjectData;
  service?: string;
  invoices?: BaseInvoiceDTO[];
}

const CreatePastInvoiceDialog: React.FC<CreatePastInvoiceDialogProps> = ({ open, onClose, onSave, projectData, service, invoices }) => {
  const handleSave = (invoice: CreateInvoiceDTO) => {
    onSave(invoice);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>Add Past Invoice</DialogTitle>
      <DialogContent>
        <CreateInvoice
          projectData={projectData}
          onSaveInvoice={handleSave}
          onCancel={onClose}
          service={service}
          isMonitoringReport={true}
          mode='past'
          invoices={invoices}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CreatePastInvoiceDialog;
